
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 20.007 19.98\" id=\"icon-arrow-down\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M19.994,9.99c0-5.524-4.474-10.003-9.991-10.003c-5.517,0-9.989,4.479-9.989,10.003\r\n\tc0,5.525,4.473,10.004,9.989,10.004C15.52,19.994,19.994,15.515,19.994,9.99z M9.69,16.862l-6.463-6.473\r\n\tc-0.149-0.15-0.151-0.402-0.002-0.55l1.178-1.182c0.16-0.155,0.395-0.144,0.551-0.005l3.834,3.851L8.79,3.369\r\n\tC8.789,3.15,8.971,2.973,9.176,2.974l1.643-0.001c0.212,0.002,0.391,0.18,0.392,0.396l-0.001,9.135l3.836-3.848\r\n\tc0.154-0.142,0.397-0.153,0.551,0l1.187,1.187c0.149,0.144,0.146,0.396-0.007,0.547l-6.47,6.47c-0.112,0.111-0.18,0.146-0.308,0.147\r\n\tC9.879,17.007,9.804,16.97,9.69,16.862z\"/> </symbol>";
module.exports = sprite.add(image, "icon-arrow-down");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/arrow-down.svg
 ** module id = 140
 ** module chunks = 24
 **/